import React from "react";

export const IndeterminateCheckbox = ({ indeterminate, ...props }) => {
  return <input type="checkbox" {...props} />;
};
